import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/styles'
import {
  SortingState, SelectionState, FilteringState, GroupingState,
  IntegratedFiltering, IntegratedGrouping, IntegratedSelection,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  Table, TableHeaderRow, TableFilterRow, TableGroupRow,
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class TechSpecGrid extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
        columns: [
          { name: "category", title: "Category" },
          { name: "feature", title: "Feature" },
          { name: "property", title: "Property" }
        ],
        rows: [
          { category: 'Optics & Imaging', feature: 'Standard Lense', property: '4.2 ±5% mm (Manual Focus) f/2.1 [2]' },
          { category: 'Optics & Imaging', feature: 'Viewing Angle', property: 'approx. 90° (diag.)' },
          { category: 'Optics & Imaging', feature: 'Optical Zoom', property: 'No' },
          { category: 'Optics & Imaging', feature: 'CMOS Sensor', property: 'Panasonic MN34229 1080p 1/3" CMOS Wide Dynamic Range [1]' },
          { category: 'Optics & Imaging', feature: 'Active Pixel Area', property: '5,346 (H) µm x 3,003 (V) µm' },
          { category: 'Optics & Imaging', feature: 'Resolution', property: '2.12 Megapixel' },
          { category: 'Optics & Imaging', feature: 'Supported Resolutions', property: '1080p, 320p, 160p' },
          { category: 'Optics & Imaging', feature: 'Illumination', property: '0.05 Lux @ f/2.1' },
          { category: 'Optics & Imaging', feature: 'Video Compression', property: 'h.264, MJPEG, JPG' },
          { category: 'Optics & Imaging', feature: 'h.264 Bitrate', property: '90 kbps - 4.096 kbps' },
          { category: 'Optics & Imaging', feature: 'Framerate', property: 'up to 30fps' },
          { category: 'Optics & Imaging', feature: '# of Parallel Streams', property: '3' },
          { category: 'Optics & Imaging', feature: 'Video Overlay', property: 'Date, Time, Camera Name' },
          { category: 'Optics & Imaging', feature: 'Video Parameter', property: 'Brightness, Contrast, Saturation, Sharpness, Gamma, Illumination' },
          { category: 'Optics & Imaging', feature: 'Day / Night Switch', property: 'Yes' },
          { category: 'Optics & Imaging', feature: 'White balance', property: 'Automatic' },
          { category: 'Optics & Imaging', feature: 'Electronic Shutter', property: 'Automatic' },
          { category: 'Optics & Imaging', feature: 'Flip / Mirror Video', property: 'Yes / Yes' },
          { category: 'Night Vision', feature: 'Infrared LEDs', property: '12 LEDs @ 850 nm' },
          { category: 'Night Vision', feature: 'IR Modes', property: 'off/automatic' },
          { category: 'Night Vision', feature: 'max. Range', property: '8 - 12 m' },
          { category: 'Night Vision', feature: 'intgr. IRcut Filter', property: 'Yes (automatic)' },
          { category: 'Connection', feature: 'Network Interface', property: '10Base-T/100Base-TX Ethernet Port / WLAN IEEE 802.11b/g/n' },
          { category: 'Connection', feature: 'Network Protocols', property: 'TCP/IP, DHCP, PPPoE, ARP, FTP, SMTP, DNS, NTP, UPnP, HTTP, TCP, UDP, MQTT' },
          { category: 'Connection', feature: 'Transfer Encryption', property: 'HTTPS & FTPS' },
          { category: 'Connection', feature: 'Free DDNS Address', property: 'Yes' },
          { category: 'Connection', feature: 'Free P2P UID', property: 'Yes' },
          { category: 'Features', feature: 'Access Protection', protection: 'Username/Password - 3 Level Authorization' },
          { category: 'Features', feature: 'Motion Detection', protection: 'Yes (software Analysis + PIR)' },
          { category: 'Features', feature: 'Alarm I/O', protection: 'No - but integrated heat sensor (PIR) for motion detection [3]' },
          { category: 'Features', feature: 'PIR Detector Angle', protection: '120° horizontal view' },
          { category: 'Features', feature: 'PIR Detector Range', protection: '5 meter' },
          { category: 'Features', feature: 'Alarm Notifications', protection: 'Email/FTP/HTTP (Alarmserver)/Push' },
          { category: 'Features', feature: 'Alarm Pre-Recording', protection: 'Yes (3s)' },
          { category: 'Features', feature: 'Photoseries', protection: 'Yes (to SD Card and FTP server)' },
          { category: 'Features', feature: 'SD Card', protection: 'Removable microSDHC card up to 128GB (16GB included) [5]' },
          { category: 'Features', feature: 'Cloud Storage', protection: 'Yes (optional)' },
          { category: 'Features', feature: 'Pan & Tilt', protection: 'No' },
          { category: 'Features', feature: 'Audio', protection: 'Integrated Loudspeaker / Audio Out (3.5mm Headphone Jack)' },
          { category: 'Features', feature: 'Microphone', protection: 'Integrated Microphone' },
          { category: 'Features', feature: 'Scheduled & Alarm Recording', protection: 'Yes' },
          { category: 'Physical Details', feature: 'Casing', property: 'Metal (White)' },
          { category: 'Physical Details', feature: 'Mount', property: 'Wall & Ceiling Mount' },
          { category: 'Physical Details', feature: 'Operating Temperature', property: '-5°C to 55°C' },
          { category: 'Physical Details', feature: 'Power Socket', property: '110V - 230V' },
          { category: 'Physical Details', feature: 'Network Cable', property: '3m Cat5e' },
          { category: 'Physical Details', feature: 'Power Supply', property: '110-240V ac @ 50-60Hz to 5V dc and 2000mA - cable length: 3m' },
          { category: 'Physical Details', feature: 'Power Plug', property: '2.1mm In / 5.5mm Out' },
          { category: 'Physical Details', feature: 'Power Consumption', property: 'max. 7,5W (3W in normal operation)' },
          { category: 'Physical Details', feature: 'Height/Width/Depth', property: '12.2cm/11.5cm/10.2cm' },
          { category: 'Physical Details', feature: 'Certification', property: 'CE, FCC, RoHS' },
        ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns} >

          <FilteringState />

          <SortingState
            defaultSorting={[
              { columnName: 'category', direction: 'asc' },
            ]}
          />
          <GroupingState
            defaultGrouping={[{ columnName: 'category' }]}
            defaultExpandedGroups={['Optics & Imaging']}
          />
          <SelectionState />

          <IntegratedFiltering />
          <IntegratedGrouping />
          <IntegratedSelection />
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
          <TableFilterRow />
          <TableGroupRow />
        </Grid>
      </Paper>
    );
  }
}

TechSpecGrid.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(TechSpecGrid)























































































































  












































































































  































































































































